import { Loader2 } from "lucide-react";
import { useArtistReviews } from "@/hooks/useReviews";
import { ReviewCard } from "./ReviewCard";

interface ArtistReviewsSectionProps {
  artistId: string;
  artistName?: string;
}

export function ArtistReviewsSection({ artistId }: ArtistReviewsSectionProps) {
  const { data: reviews, isLoading, error } = useArtistReviews(artistId);

  // Don't render section if no reviews, loading, or error
  if (error || (!isLoading && (!reviews || reviews.length === 0))) {
    return null;
  }

  return (
    <section className="mt-8">
      <div className="p-6 rounded-xl bg-[var(--color-bg-card)] border border-[var(--color-border)]">
        <h2 className="font-semibold text-[var(--color-text)] mb-4">
          Client Reviews
        </h2>

        {isLoading && (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin text-[var(--color-primary)]" />
          </div>
        )}

        {!isLoading && reviews && reviews.length > 0 && (
          <div className="space-y-4">
            {reviews.map((review) => (
              <ReviewCard
                key={review.id}
                review={review}
                showArtist={false}
                showImage
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
